<template>
    <div class="context common_table_view">
        <div class="header">
            <div class="search search_box">
                <el-form :model="searchForm" inline size="small">
                    <el-form-item label="时间范围">
                        <el-date-picker
                                v-model="searchForm.date"
                                type="datetimerange"
                                :picker-options="pickerOptions"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                @change="getTableData()"
                                align="right">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="getTableData()" type="primary">搜索</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="btn_box">
                <el-button @click="addView" size="small">添加直播</el-button>
            </div>
        </div>
        <div class="table">
            <el-table :data="tableData"
                      stripe
                      width="100%"
                      height="100%">
                <el-table-column v-for="(item, index) in columnData"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :width="item.width"
                                 :formatter="item.formatter"
                                 :fixed="item.fixed"
                                 show-overflow-tooltip
                                 :key="index"></el-table-column>
                <el-table-column label="操作" width="300">
                    <template slot-scope="scope">
                        <span class="table_btn"
                              @click="openDialog(scope.row)">
                            <i class="el-icon-upload2"></i>
                            上传视频
                        </span>
                        <span class="table_btn"
                              @click="editRow(scope.row)">
                            <i class="el-icon-edit"></i>
                            编辑
                        </span>
                        <span class="table_del_btn"
                              @click="delRow(scope.row)">
                            <i class="el-icon-delete"></i>
                            删除
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="bottom_page">
            <page-view @getTableList="handleCurrentChange"
                       :currentPage="currentPage"
                       :pageSize="pageSize"
                       :total="total"></page-view>
        </div>

        <el-dialog :title="dialog_title"
                   :visible.sync="dialogVisible_live"
                   :modal-append-to-body="false"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :show-close="false"
                   width="500px">
            <div class="upload_box" style="height: 90px;">
                <el-upload action="string"
                           ref="uploadVideo"
                           :file-list="fileList"
                           :multiple="false"
                           accept=".mp4"
                           :limit="1"
                           :auto-upload="false"
                           :on-remove="removeFile"
                           :on-success="successFile"
                           :http-request="uploadNow"
                           :before-upload="beforeUpload"
                           class="upload_demo">
                    <el-button size="small" type="primary">选择上传视频</el-button>
                </el-upload>
                <el-progress style="width: 200px;margin-top: 8px"
                             v-if="showProgress"
                             :percentage="progressPercent" />
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible_live = false">取 消</el-button>
                <el-button type="primary"
                           @click="submitVideo">上 传</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {mapMutations, mapState} from "vuex";
    import {clone} from "@/global/utils";

    export default {
        name: "tableView",
        data() {
            const showLive = (row, column, cellValue, index) => {
                return cellValue ? '有' : '暂无'
            };
            return {
                searchForm: {
                    date: [],
                },
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '未来一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },

                tableData: [],
                columnData: [
                    {label: '标题', prop: 'title'},
                    {label: '开始时间', prop: 'start_time'},
                    {label: '结束时间', prop: 'end_time'},
                    {label: '讲师', prop: 'lecturer'},
                    {label: '医院', prop: 'hospital_name'},
                    {label: '科室', prop: 'department'},
                    {label: '回放视频', prop: 'video_file_id', formatter: showLive},
                ],

                pageSize: 50,
                currentPage: 1,
                total: 0,

                dialogVisible_live: false,
                dialog_title: '上传视频',
                fileList: [],
                showProgress: false,
                progressPercent: 0,

                select_row: null,
            }
        },
        mounted() {
            this.getTableData();
            this.$eventBus.$on("pollPort", () => {
                this.getTableData()
            })
        },
        beforeDestroy() {
            this.$eventBus.$off('pollPort');
        },
        methods: {
            ...mapMutations('manageData', {
                setLiveData: 'setLiveData'
            }),
            beforeUpload(file) {
                const isLimit = file.size / 1024 / 1024 < 10;
                if(!isLimit) {
                    this.$message.warning('文件不能超过10M！');
                    return false
                }
                return true
            },
            uploadNow(params) {
                console.log(params,'upload');
                this.showProgress = true;
                this.progressPercent = 0;

                const file = params.file;
                let forms = new FormData(); // 实例化一个formData，用来做文件上传
                forms.append('file', file);
                const uploadProgressEvent = progressEvent => {
                    this.progressPercent = Math.floor((progressEvent.loaded * 100) / progressEvent.total)
                };
                let configs = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: uploadProgressEvent
                };
                this.httpPost(`/live/upload_video/${this.select_row.live_id}`, forms, configs).then(res => {
                    if(res.data) {
                        this.$message.success('上传成功');
                        this.dialogVisible_live = false;
                        this.getTableData(this.currentPage)
                    } else {
                        this.showProgress = false;
                    }
                })
            },
            successFile(response, file, fileList) {
                console.log(response, file, fileList, 'success');
                // this.dialogVisible_live = false;
            },
            removeFile(file, fileList) {
                console.log(file,fileList, 'del');
            },
            submitVideo() {
                this.$refs.uploadVideo.submit()
            },

            addView() {
                this.setLiveData(null);
                this.$emit('changeTopTab', 'addView')
            },
            editRow(row) {
                this.httpGet(`/live/${row.live_id}`).then(res => {
                    this.setLiveData(res.data);
                    this.$emit('changeTopTab', 'addView')
                })
            },
            delRow(row) {
                this.$confirm('确定删除该直播么？').then(() => {
                    this.httpDel(`/live/${row.live_id}`).then(res => {
                        this.$message.success('删除成功！');
                        if (this.tableData.length === 1) {
                            let page = this.currentPage === 1 ? 1 : this.currentPage -1;
                            this.getTableData(page)
                        } else {
                            this.getTableData(this.currentPage)
                        }
                    })
                }).catch(() => {})
            },
            openDialog(row) {
                this.select_row = row;
                this.dialog_title = `上传视频（${row.title}）`;
                this.dialogVisible_live = true;
                this.showProgress = false;
                console.log(row, '244');
                this.fileList = [];
            },

            handleCurrentChange(val) {
                this.getTableData(val)
            },
            getTableData(v = 1) {
                let params = {
                    page: v,
                    page_size: this.pageSize
                };
                if(this.searchForm.date && this.searchForm.date.length > 0) {
                    params.start_time = this.searchForm.date[0];
                    params.end_time = this.searchForm.date[1];
                }
                this.httpGet('/live/list', params).then(res => {
                    this.tableData = res.data.data_list;
                    this.total = res.data.total;
                    this.$nextTick(() => {
                        this.currentPage = v
                    })
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>